import Button from "@/common/components/Button";
import { getFilenameFromUrl } from "@/common/utils/getFilenameFromUrl";
import { DownloadIcon } from "lucide-react";
import { MaintenanceFiscalAssessmentDocumentGroupData } from "../../forwardings/types/forwardings/fiscalAssessmentEntry/fiscalAssessmentEntry.type";
import FiscalAssessmentDocumentGroupDocumentDisapprove from "./FiscalAssessmentDocumentGroupDocumentDisapprove";
import FiscalAssessmentDocumentGroupDocumentApprove from "./FiscalAssessmentDocumentGroupDocumentApprove";
import { cn } from "@/common/utils/cn";
import ResumeItem from "@/common/components/ResumeItem";

interface FiscalAssessmentDocumentGroupDocumentProps {
  document: MaintenanceFiscalAssessmentDocumentGroupData['documents'][number];
}

const FiscalAssessmentDocumentGroupDocument = ({
  document,
}: FiscalAssessmentDocumentGroupDocumentProps) => {
  const isApproved = document?.last_review?.state === 'approved';
  const isDisapproved = document?.last_review?.state === 'disapproved';

  return (
    <div className={cn(
      'relative flex flex-col justify-between p-4 gap-5 bg-white-200 rounded-lg',
      isApproved && 'bg-success-op',
      isDisapproved && 'bg-yellow-op-2',
    )}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="italic text-xs overflow-hidden text-ellipsis break-all">
          {getFilenameFromUrl(document?.file?.url) || 'Documento'}
        </div>

        <div className="flex gap-3 ml-auto">
          {!isDisapproved ? (
            <FiscalAssessmentDocumentGroupDocumentDisapprove
              documentId={document.id}
            />
          ) : (
            <Button variant="yellow" disabled className="w-[120px]">
              Declinado
            </Button>
          )}

          {!isApproved ? (
            <FiscalAssessmentDocumentGroupDocumentApprove
              documentId={document.id}
            />
          ) : (
            <Button variant="success" disabled className="w-[120px]">
              Aprovado
            </Button>
          )}
        </div>
      </div>

      <div className="flex items-end justify-between">
        <div>
          {isDisapproved && (
            <ResumeItem
              className="text-xs"
              valueClassName="font-semibold text-sm"
              label="Justificativa"
              value={document.last_review?.description || '--'}
            />
          )}
        </div>

        <a
          href={document.file.url}
          download={getFilenameFromUrl(document.file.url) || 'Documento'}
          target="_blank"
        >
          <DownloadIcon />
        </a>
      </div>
    </div>
  );
}

export default FiscalAssessmentDocumentGroupDocument;
